import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-release-note',
  templateUrl: './release-note.component.html',
  styleUrls: ['./release-note.component.css']
})

export class ReleaseNoteComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
